const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const SOUND_GALLERY_BASE_URL = (
  process.env.REACT_APP_AUDIO_BASE_URL ||
  (isLocalDev
    ? 'http://localhost:3002/OTRRADIO/assets/SOUND GALLERY'
    : 'https://wave-form.studio/assets/otr-audio')
).replace(/\/+$/, '');

const publicBase = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');

export const FULL_CATALOG_BASE_URL = (
  process.env.REACT_APP_FULL_CATALOG_AUDIO_URL ||
  (isLocalDev
    ? 'http://localhost:3001/catalog-audio'
    : `${typeof window !== 'undefined' ? window.location.origin : ''}${publicBase}/catalog-audio`)
).replace(/\/+$/, '');

const normalizeFlatFilename = (name = '') =>
  name.trim().replace(/\s+/g, '-');

export const getSoundGalleryTrackUrl = (track) => {
  const raw = (track?.filename || track?.url || '').trim();
  if (!raw) return '';
  return `${SOUND_GALLERY_BASE_URL}/${encodeURIComponent(normalizeFlatFilename(raw))}`;
};

export const getFullCatalogTrackUrl = (track) => {
  const rel = (track?.relativePath || track?.filename || '').trim();
  if (!rel) return '';
  const encoded = rel.split('/').map((part) => encodeURIComponent(part)).join('/');
  return `${FULL_CATALOG_BASE_URL}/${encoded}`;
};
